import React, { useState } from "react";
import DataTable from "components/DataTable";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { useSession } from "hooks/useSession";

// ── Deleted Members Table Config ──
const DeletedMembersConfig = {
  title:   "Deleted Members",
  columns: [
    { key: "id",           label: "ID"           },
    { key: "name",         label: "Name"         },
    { key: "Email",        label: "Email"        },
    { key: "Phone",        label: "Phone"        },
    { key: "Role",         label: "Role"         },
    { key: "wallet_amount",label: "Wallet"       },
    { key: "joining_date", label: "Joining Date" },
    { key: "deleted_at",   label: "Deleted At"   },
  ],
};

const DeletedMembersPage = () => {
  const { userid }    = useSession();
  const [refresh]     = useState(0);
  const role          = localStorage.getItem("role");

  const formdata = new FormData();
  formdata.append("action",    "GETDELETED");
  formdata.append("role_name", role);
  formdata.append("userid",    userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/retailer_action",
    DeletedMembersConfig,
    formdata,
    refresh
  );

  return (
    <div>
      <div className="row m-1">
        <div className="col-12">
          <h4 className="main-title">Deleted Members</h4>
          <ul className="app-line-breadcrumbs mb-3">
            <li>
              <a className="f-s-14 f-w-500" href="#">
                <span>
                  <i className="ph-duotone ph-users f-s-16"></i> Members
                </span>
              </a>
            </li>
            <li className="active">
              <a className="f-s-14 f-w-500" href="#">Deleted Members</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="row m-1">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between">
              <h5 className="card-title mb-0">
                🗑️ Deleted Members List
              </h5>
              <span className="badge bg-danger">
                {tableData?.data?.length || 0} Deleted
              </span>
            </div>
            <div className="card-body">
              <DataTable
                config={DeletedMembersConfig}
                tableData={tableData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletedMembersPage;